export default __webpack_public_path__ + "static/abcares-serve-3352b3ae5cc6e8f16260a6bcd558901b.jpg";